import React from 'react';
import { useTranslation } from 'react-i18next';

import { UseMutationResult } from '@tanstack/react-query';

import { ApiError } from '../../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../../Shared/interfaces/ApiResponse';
import { ErrorDisplay } from '../../../../../Shared/components/ErrorDisplay/ErrorDisplay';
import { CustomConfirmationModal } from '../../../../../UiComponentsLibrary/CustomConfirmationModal';
import { QueueSheetManagementRows } from '../../interface/QueueSheetInterface';
import { LeftAlignedErrorContainer } from '../../../../../UserManagement/components/UserManagement/UserManagement.styles';

interface BookingRestoreModalProps {
  isRestoreModalOpen: boolean;
  bookingToRestore: QueueSheetManagementRows | null;
  handleRestoreConfirm: () => void;
  handleRestoreCancel: () => void;
  restoreBookingMutation: UseMutationResult<
    ApiResponseKeys,
    ApiError,
    string,
    unknown
  >;
}

const BookingRestoreModal = ({
  isRestoreModalOpen,
  bookingToRestore,
  handleRestoreConfirm,
  handleRestoreCancel,
  restoreBookingMutation,
}: BookingRestoreModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomConfirmationModal
      isOpen={isRestoreModalOpen}
      title={t('restore-booking-modal-title')}
      message={t('restore-booking-modal-message', {
        entryId: bookingToRestore?.entryId,
      })}
      onConfirmCb={handleRestoreConfirm}
      onCancelCb={handleRestoreCancel}
      confirmButtonText={t('restore-booking-modal-confirmation-button-label')}
    >
      {restoreBookingMutation.isError && (
        <LeftAlignedErrorContainer>
          <ErrorDisplay error={restoreBookingMutation.error} />
        </LeftAlignedErrorContainer>
      )}
    </CustomConfirmationModal>
  );
};

export default BookingRestoreModal;
